import React, { useEffect } from 'react';
import './cta.scss';
import logo from '../../assets/logo.svg';
import Hyperlink from '../Hyperlink/Hyperlink';
function Cta({ ctaRef }) {
  const hyperlinkData = [
    {
      href: 'https://us-keepexploring.canada.travel/',
      copy: 'Destination Canada'
    }
  ];
  useEffect(() => {
    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach((entry) => {
          if (entry.intersectionRatio > 0.3) {
            ctaRef.current.style.opacity = '1';
          }
        });
      },
      { threshold: [0, 0.3] }
    );
    observer.observe(ctaRef.current);
  }, [ctaRef]);
  return (
    <section className="cta" ref={ctaRef}>
      <a
        href="https://us-keepexploring.canada.travel/"
        target="_blanc"
        rel="noreferrer"
        aria-label="Visit Destination Canada homepage"
      >
        <img className="cta__logo" src={logo} alt="" />
      </a>
      <span className="cta__head">This is Canada</span>
      <p className="copy">
        Want to see more of Canada? Need some vacation time? Ready to refresh your view? Visit{' '}
        <Hyperlink hyperlinkData={hyperlinkData[0]} /> for more ideas to explore the country’s
        vibrant cities, natural wonders, and unique cultures.
      </p>

      <div className="carouselButton">
        <a
          href="https://us-keepexploring.canada.travel/"
          rel="noreferrer"
          target="_blanc"
          aria-label="Visit Destination Canada Keep Exploring page"
        >
          Find the Right getaway for you
        </a>
      </div>
    </section>
  );
}

export default Cta;
